import React, {useState, useEffect, useContext} from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import Global from "../../APIConfig";
import  axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';

function HubAdd(){
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const [Countrylist, setCountrylist] = useState([]);
    const [Citylist, setCitylist] = useState([]);
    const [Name, setName] = useState('');
    const [HubName, setHubName] = useState('');
    const [Phone, setPhone] = useState('');
    const [Email, setEmail] = useState('');
    const [Zip, setZip] = useState('');
    const [Country, setCountry] = useState('');
    const [City, setCity] = useState('');
    const [Password, setPassword] = useState('');
    const [ConfirmPass, setConfirmPass] = useState('');
    const [Address, setAddress] = useState('');
    const [loading, setloading] = useState(false);
    const [defaultCountry, setDefaultCountry] = useState('');
    const [profileimg, setProfileimg] = useState('');
    const [commissionPercentageBooking, setCommissionPercentageBooking] = useState('0');
    const [baseCommissionBooking, setBaseCommissionBooking] = useState('0');
    const [commissionPercentageprs, setCommissionPercentageprs] = useState('0');
    const [baseCommissionprs, setBaseCommissionprs] = useState('0');
    const [commissionPercentageManifest, setCommissionPercentageManifest] = useState('0');
    const [baseCommissionManifest, setBaseCommissionManifest] = useState('0');
    const [commissionPercentagedrs, setCommissionPercentagedrs] = useState('0');
    const [baseCommissiondrs, setBaseCommissiondrs] = useState('0');
    const { defaultCurrency } = useContext(AppContext);

    useEffect(()=>{
        GetCountrylist();
        GetdefaultCountry();
    },[]);
    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
          })
          .catch(function (error) {
            setloading(false);
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
    }
    const GetdefaultCountry=()=>
    {
        axios({
            method: 'post',
            url: Global.baseUrl+'defaultcountryname',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setDefaultCountry(data);
                setCountry(data);
                GetCityList(data);
            }
          })
          .catch(function (error) {
            setloading(false);
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
    }
    const GetCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCitylist(data);
            }
            else
            {
                setCitylist([]);
            }
          })
          .catch(function (error) {
            setloading(false);
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
    }
    const handleCountryChange = (val) => {
        setCountry(val);
        GetCityList(val);
    };
    const handleCityChange = (val) => {
        setCity(val);
    };
    const handleSubmit=()=>{
        if(Name==""){
            toast.warning('Name is Required');
        }
        else if(HubName==""){
            toast.warning('Hub Name is Required');
        }
        else if(Phone==""){
            toast.warning('Mobile No. is Required');
        }
        else if(Email==""){
            toast.warning('Email is Required');
        }
        else if(Zip==""){
            toast.warning('Postal Code is Required');
        }
        else if(Country==""){
            toast.warning('Please Select Country');
        }
        else if(City==""){
            toast.warning('Please Select City');
        }
        else if(Password==""){
            toast.warning('Password is Required');
        }
        else if(ConfirmPass==""){
            toast.warning('Confirm Password is Required');
        }
        else if(Password!=ConfirmPass){
            toast.warning('Password and Confirm Password Must Be Same');
        }
        else if(Address==""){
            toast.warning('Address is Required');
        }
        else{
            setloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'HubAdd',
                headers:headers2,
                data: {
                    Name:Name,
                    HubName:HubName,
                    Phone:Phone,
                    Email:Email,
                    Zip:Zip,
                    Country:Country,
                    City:City,
                    Password:Password,
                    ConfirmPass:ConfirmPass,
                    Address:Address,
                    profile_image:profileimg,
                    base_commissionprs_booking:baseCommissionBooking,
                    commission_percentage_booking:commissionPercentageBooking,
                    base_commissionprs:baseCommissionprs,
                    commission_percentageprs:commissionPercentageprs,
                    base_commissiond_manifest:baseCommissionManifest,
                    commission_percentage_manifest:commissionPercentageManifest,
                    base_commissiondrs:baseCommissiondrs,
                    commission_percentagedrs:commissionPercentagedrs
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/HubList');
                      }, 1000);
                }else{
                    toast.warning(response.data.message);
                }
                setloading(false);
              })
              .catch(function (error) {
                setloading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
              });
        }
    }
    return(
        <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
                <section className="left_sub_menu">
                <div className="row">
                    <div className="col-12 col-md">
                        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                            <div className="d-block mb-4 mb-md-0">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                    <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                        <li className="breadcrumb-item">
                                            <a href="/Admin-Dash">
                                            <i className="bx bx-home text-primary-400 fs-6"></i>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">Add Hub</li>
                                    </ol>
                                </nav>
                                <div className="d-flex justify-content-between">
                                    <div className="">
                                        <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                        <i className="bx bx-arrow-back "></i>
                                        </button>
                                    </div>
                                    <div className="ps-2 ">
                                        <h2 className="h4">Add Hub</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-toolbar mb-2 mb-md-0">
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                            <h6>Add Hub</h6>
                                <div className="row">
                                    <div className="col-12 mb-3 mt-4">
                                        <div className="row">
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Name: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" onChange={(e)=>setName(e.target.value)} placeholder="Please Enter Name" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Hub Name: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" onChange={(e)=>setHubName(e.target.value)} placeholder="Please Enter Hub Name" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Mobile No.: <span className="text-danger">*</span></label>
                                                <input type="number" className="form-control" onChange={(e)=>setPhone(e.target.value)} placeholder="Please Enter Mobile No." />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Email: <span className="text-danger">*</span></label>
                                                <input type="email" className="form-control" onChange={(e)=>setEmail(e.target.value)} placeholder="Please Enter Email" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Postal Code: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" onChange={(e)=>setZip(e.target.value)} placeholder="Please Enter Postal Code" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <div><label htmlFor="email" className="form-label">Country: <span className="text-danger">*</span></label></div>
                                                <select className="form-select" onChange={(e)=>handleCountryChange(e.target.value)}>
                                                    <option value="">-- Please Select --</option>
                                                    {Countrylist.map((list)=>{
                                                        return (
                                                            <option value={list.country} selected={list.country == defaultCountry}>{list.country}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            <div className="col-4 mb-3">
                                                <div><label htmlFor="email" className="form-label">City: <span className="text-danger">*</span></label></div>
                                                <select className="form-select" onChange={(e)=>handleCityChange(e.target.value)}>
                                                    <option value="">-- Please Select --</option>
                                                    {Citylist.map((list)=>{
                                                        return (
                                                            <option value={list.value}>{list.label}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Password: <span className="text-danger">*</span></label>
                                                <input type="password" className="form-control" onChange={(e)=>setPassword(e.target.value)} placeholder="Please enter password" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Confirm Password: <span className="text-danger">*</span></label>
                                                <input type="password" className="form-control" onChange={(e)=>setConfirmPass(e.target.value)} placeholder="Please confirm Password" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Image: <span className="text-danger">*</span></label>
                                                <input type="file" className="form-control" onChange={(e)=>setProfileimg(e.target.files[0])} placeholder="Please Select File" />
                                            </div>
                                            <div className="col-12 mb-3">
                                                <label htmlFor="" className="form-label">Address: <span className="text-danger">*</span></label>
                                                <textarea className="form-control" rows={5} onChange={(e)=>setAddress(e.target.value)} placeholder="Please Enter Hub Address" ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="col-12 mb-3 mt-4">
                                        <h6 className="mb-4">Set Hub Commission Structure</h6>
                                        <p className="text-muted mb-4">Configure commission rates for different service types. Each service has a base commission (fixed amount) and a percentage commission.</p>
                                        
                                        <div className="row">
                                            {/* Booking Commission */}
                                            <div className="col-lg-6 mb-4">
                                                <div className="card border h-100">
                                                    <div className="card-header bg-primary bg-opacity-10 border-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <div className="bg-primary text-white rounded-circle p-2 me-3">
                                                                <i className="fas fa-calendar-check"></i>
                                                            </div>
                                                            <div>
                                                                <h6 className="mb-0">Booking Commission</h6>
                                                                <small>For every successful booking</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Base Commission</span>
                                                                    <span className="badge bg-primary">Fixed Amount</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text">{defaultCurrency}</span>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setBaseCommissionBooking(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Fixed minimum amount for each booking
                                                                </small>
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Commission Percentage</span>
                                                                    <span className="badge bg-success">Percentage</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setCommissionPercentageBooking(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                    <span className="input-group-text">%</span>
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Percentage of total booking amount
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* PRS Commission */}
                                            <div className="col-lg-6 mb-4">
                                                <div className="card border h-100">
                                                    <div className="card-header bg-warning bg-opacity-10 border-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <div className="bg-warning text-white rounded-circle p-2 me-3">
                                                                <i className="fas fa-box-open"></i>
                                                            </div>
                                                            <div>
                                                                <h6 className="mb-0">Pickup (PRS) Commission</h6>
                                                                <small>For every successful pickup</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Base Commission</span>
                                                                    <span className="badge bg-primary">Fixed Amount</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text">{defaultCurrency}</span>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setBaseCommissionprs(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Fixed amount for each pickup
                                                                </small>
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Commission Percentage</span>
                                                                    <span className="badge bg-success">Percentage</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setCommissionPercentageprs(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                    <span className="input-group-text">%</span>
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Percentage of pickup amount
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Manifest Commission */}
                                            <div className="col-lg-6 mb-4">
                                                <div className="card border h-100">
                                                    <div className="card-header bg-info bg-opacity-10 border-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <div className="bg-info text-white rounded-circle p-2 me-3">
                                                                <i className="fas fa-clipboard-list"></i>
                                                            </div>
                                                            <div>
                                                                <h6 className="mb-0">Manifest Commission</h6>
                                                                <small>For every successful manifest</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Base Commission</span>
                                                                    <span className="badge bg-primary">Fixed Amount</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text">{defaultCurrency}</span>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setBaseCommissionManifest(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Fixed amount for each manifest
                                                                </small>
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Commission Percentage</span>
                                                                    <span className="badge bg-success">Percentage</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setCommissionPercentageManifest(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                    <span className="input-group-text">%</span>
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Percentage of manifest amount
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* DRS Commission */}
                                            <div className="col-lg-6 mb-4">
                                                <div className="card border h-100">
                                                    <div className="card-header bg-danger bg-opacity-10 border-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <div className="bg-danger text-white rounded-circle p-2 me-3">
                                                                <i className="fas fa-truck"></i>
                                                            </div>
                                                            <div>
                                                                <h6 className="mb-0">Delivery (DRS) Commission</h6>
                                                                <small>For every successful delivery</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Base Commission</span>
                                                                    <span className="badge bg-primary">Fixed Amount</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text">{defaultCurrency}</span>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setBaseCommissiondrs(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Fixed amount for each delivery
                                                                </small>
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label d-flex justify-content-between">
                                                                    <span>Commission Percentage</span>
                                                                    <span className="badge bg-success">Percentage</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control" 
                                                                        onChange={(e)=>setCommissionPercentagedrs(e.target.value)} 
                                                                        placeholder="0.00" 
                                                                    />
                                                                    <span className="input-group-text">%</span>
                                                                </div>
                                                                <small className="text-muted mt-1 d-block">
                                                                    Percentage of delivery charge
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                {loading==false?
                                    <div className="d-grid col-md-2 mt-2">
                                        <button className="btn btn-primary" onClick={()=>handleSubmit()}>Submit</button>
                                    </div>
                                    :
                                    <div className="d-grid col-md-2 mt-2">
                                        <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                                    </div>
                                    }
                            </div>
                        </div>

                    </div>
                </div>
            </section>
                <Footer/>
            </main>
        </>
    )
}
export default HubAdd;